module.exports = __webpack_public_path__ + "img/handraw_supprimer.6ba72f0e.svg";